import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=b659f7ec&scoped=true&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=b659f7ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b659f7ec",
  null
  
)

export default component.exports